// extracted by mini-css-extract-plugin
export var container = "ShowedIndex-module--container--fItao";
export var text = "ShowedIndex-module--text--s8bx4";